import { BaseComponent } from '../base-component.js';

export class AgCard extends BaseComponent {

  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-card"><slot></slot></div>`;
  }
}

customElements.define('ag-card', AgCard);
